import { ApiRequest, RequestMethod } from "../../../request";
import { XpSourceDict, CreateXpSourceDto } from "../../../../model/Dto/Dict/XpSource";

export async function updateXpSource(id: string, dto: CreateXpSourceDto): Promise<XpSourceDict | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(`/api/xp-source/${id}`);
    apiRequest.setJsonBody(dto);

    const response: any = await apiRequest.send();
    return response.status === 200 ? response.data : null;
}
